// implementation with help from https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
const generateSHA256FromImage = async (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('no file provided'))
      return
    }

    const reader = new FileReader()

    reader.onload = async () => {
      const fileBytes = reader.result
      let hashHex = null
      try {
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', fileBytes)
        const hashArray = Array.from(new Uint8Array(hashBuffer))
        hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('') // convert bytes to hex string
      } catch (error) {
        reject(error)
        return
      }

      resolve(hashHex)
    }

    reader.onerror = () => {
      reject(new Error(`Error reading file data for ${file.name}`))
    }

    reader.readAsArrayBuffer(file)
  })
}

export default generateSHA256FromImage
